<!-- @format -->

<!-- List Content -->
<div class="item-list-container hmf-display-flex hmf-flex-column hmf-mt-m">
	<ng-container *ngIf="listConfiguration">
		<div
			*ngFor="let configuration of listConfiguration; trackBy: trackByConfiguration"
			class="item-container has-border hmf-display-flex hmf-justify-content-between hmf-flex-row hmf-flex-grow hmf-p-s"
			[ngClass]="{ 'is-clickable': !configuration.actions?.length }"
			[tabindex]="showSidePanel && shouldRenderType !== configuration.type ? -1 : 0"
			(keydown.enter)="
				!configuration.actions?.length && configuration.callback(configuration)
			"
			(click)="!configuration.actions?.length && configuration.callback(configuration)">
			<div class="hmf-display-flex hmf-align-items-center">
				<p class="item-title hmf-header-bold-s hmf-header-bold-m-m hmf-mr-xs hmf-mb-0">
					{{ configuration.title }}
				</p>
				<p
					*ngIf="!!configuration.subtitle"
					class="item-subtitle hmf-subheader-m hmf-header-l-s hmf-mb-0">
					{{ configuration.subtitle }}
				</p>
			</div>
			<ng-container *ngIf="configuration.actions?.length; else buttonAction">
				<product-reviews-review-button
					*ngFor="let action of configuration.actions; trackBy: trackByAction"
					class="item-action hmf-header-s"
					[label]="action.title"
					[isQuestions]="configuration.type === 'Questions'"
					type="link">
				</product-reviews-review-button>
			</ng-container>
			<ng-template #buttonAction>
				<homefield-icon
					width="24px"
					height="24px"
					name="chevron-right"></homefield-icon>
			</ng-template>
		</div>
	</ng-container>
</div>

<!-- Drawer Container -->
<ng-container #drawerContainer></ng-container>
